(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog"]) return;
  try {
    
  (() => {
    const ready = new WeakSet();

    function articleHref(item) {
      const link = item.querySelector('.article-card__link');
      return link ? link.getAttribute('href') : '';
    }

    function messageForCount(listing, count) {
      const template = count === 1 ? listing.dataset.loadedOne : listing.dataset.loadedOther;
      if (!template) return '';
      return template.split('__COUNT__').join(String(count));
    }

    function setFeedback(feedback, message, visible) {
      if (!feedback) return;
      feedback.textContent = message || '';
      feedback.classList.toggle('is-visible', Boolean(visible && message));
    }

    function sectionRequestUrl(href, sectionId) {
      const url = new URL(href, window.location.href);
      url.searchParams.set('section_id', sectionId);
      return url;
    }

    function bind(listing) {
      if (ready.has(listing)) return;

      const grid = listing.querySelector('[data-blog-listing-grid]');
      const feedback = listing.querySelector('[data-blog-listing-feedback]');
      const sectionId = listing.dataset.sectionId;
      if (!grid || !sectionId || !listing.querySelector('.blog-listing__load-more')) return;

      ready.add(listing);

      const button = listing.querySelector('.blog-listing__load-more');
      if (grid.id) button.setAttribute('aria-controls', grid.id);

      let loading = false;

      async function loadMore(trigger) {
        if (loading) return;

        const href = trigger.getAttribute('href');
        if (!href) return;

        loading = true;
        listing.setAttribute('aria-busy', 'true');
        trigger.setAttribute('aria-disabled', 'true');
        setFeedback(feedback, listing.dataset.loadingMessage || '', true);

        const scrollX = window.scrollX;
        const scrollY = window.scrollY;

        try {
          const requestUrl = sectionRequestUrl(href, sectionId);
          const signal =
            typeof AbortSignal !== 'undefined' && typeof AbortSignal.timeout === 'function'
              ? AbortSignal.timeout(20000)
              : undefined;

          const response = await fetch(requestUrl, {
            credentials: 'same-origin',
            signal,
          });

          if (!response.ok) throw new Error('status');

          const html = await response.text();
          if (!listing.isConnected) return;

          const doc = new DOMParser().parseFromString(html, 'text/html');
          const source = doc.querySelector('[data-blog-listing], .blog-listing');
          const sourceGrid = source
            ? source.querySelector('[data-blog-listing-grid], .blog-listing__grid')
            : null;

          if (!source || !sourceGrid) throw new Error('section');

          const next = source.querySelector('.blog-listing__load-more');
          const nextHref = next ? next.getAttribute('href') : '';
          const hasMore = Boolean(nextHref && nextHref !== href);
          const incoming = [...sourceGrid.querySelectorAll('.blog-listing__grid-item')];

          if (incoming.length === 0 && hasMore) throw new Error('empty');
          if (incoming.length > 0 && nextHref === href) throw new Error('stuck');

          const seen = new Set(
            [...grid.querySelectorAll('.blog-listing__grid-item')]
              .map(articleHref)
              .filter(Boolean)
          );

          const fragment = document.createDocumentFragment();
          const added = [];

          incoming.forEach((item) => {
            const itemHref = articleHref(item);
            if (itemHref && seen.has(itemHref)) return;
            if (itemHref) seen.add(itemHref);
            const node = document.importNode(item, true);
            added.push(node);
            fragment.appendChild(node);
          });

          if (added.length) grid.appendChild(fragment);

          window.scrollTo(scrollX, scrollY);

          const parts = [];

          if (added.length) parts.push(messageForCount(listing, added.length));
          if (!hasMore && listing.dataset.completeMessage) parts.push(listing.dataset.completeMessage);

          setFeedback(feedback, parts.join(' '), false);

          if (hasMore) {
            trigger.setAttribute('href', nextHref);
            return;
          }

          const firstLink = added[0] ? added[0].querySelector('a') : null;
          const footer = listing.querySelector('[data-blog-listing-footer]');
          if (footer) footer.remove();

          if (firstLink) {
            firstLink.focus({ preventScroll: true });
          } else if (feedback) {
            feedback.tabIndex = -1;
            feedback.focus({ preventScroll: true });
          }
        } catch {
          setFeedback(feedback, listing.dataset.errorMessage || '', true);
        } finally {
          loading = false;
          listing.removeAttribute('aria-busy');
          if (trigger.isConnected) trigger.removeAttribute('aria-disabled');
        }
      }

      listing.addEventListener('click', (event) => {
        const trigger = event.target.closest('.blog-listing__load-more');
        if (!trigger || !listing.contains(trigger)) return;
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        loadMore(trigger);
      });
    }

    function boot(scope) {
      const root = scope && scope.querySelectorAll ? scope : document;
      root.querySelectorAll('[data-blog-listing]').forEach(bind);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => boot(document), { once: true });
    } else {
      boot(document);
    }

    document.addEventListener('shopify:section:load', (event) => {
      boot(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  class FaqSection extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return

      this.initialized = true
      this.animations = new Map()
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)')

      this.querySelectorAll('[data-faq-item]').forEach((item) => {
        const header = item.querySelector('[data-faq-header]')
        const trigger = item.querySelector('[data-faq-trigger]')
        const panel = item.querySelector('[data-faq-panel]')

        if (!header || !trigger || !panel) return

        trigger.addEventListener('click', () => {
          this.toggleItem(item, trigger, panel)
        })

        header.addEventListener('click', (event) => {
          if (event.target.closest('button, a')) return
          trigger.click()
        })
      })

      this.handleBlockSelect = (event) => {
        const item = event.target.closest('[data-faq-item]')
        if (!item || !this.contains(item)) return

        const trigger = item.querySelector('[data-faq-trigger]')
        const panel = item.querySelector('[data-faq-panel]')
        if (trigger && panel && trigger.getAttribute('aria-expanded') !== 'true') {
          this.setItemState(item, trigger, panel, true)
        }
      }

      document.addEventListener('shopify:block:select', this.handleBlockSelect)
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:block:select', this.handleBlockSelect)
      this.initialized = false
    }

    toggleItem(item, trigger, panel) {
      const expanded = trigger.getAttribute('aria-expanded') === 'true'
      this.setItemState(item, trigger, panel, !expanded)
    }

    setItemState(item, trigger, panel, expanded) {
      const currentHeight = panel.hidden ? 0 : panel.getBoundingClientRect().height
      const runningAnimation = this.animations.get(panel)

      if (runningAnimation) {
        runningAnimation.cancel()
        this.animations.delete(panel)
      }

      trigger.setAttribute('aria-expanded', String(expanded))
      item.classList.toggle('is-expanded', expanded)

      if (this.reduceMotion.matches) {
        panel.hidden = !expanded
        panel.classList.remove('is-animating')
        return
      }

      if (expanded) panel.hidden = false

      const targetHeight = expanded ? panel.scrollHeight : 0
      panel.classList.add('is-animating')

      const animation = panel.animate(
        [
          { height: `${currentHeight}px`, opacity: expanded ? 0 : 1 },
          { height: `${targetHeight}px`, opacity: expanded ? 1 : 0 }
        ],
        {
          duration: 250,
          easing: 'ease',
          fill: 'both'
        }
      )

      this.animations.set(panel, animation)

      animation.onfinish = () => {
        if (this.animations.get(panel) !== animation) return

        this.animations.delete(panel)
        panel.classList.remove('is-animating')
        animation.cancel()
        panel.hidden = !expanded
      }
    }
  }

  if (!customElements.get('faq-section')) {
    customElements.define('faq-section', FaqSection)
  }

  } catch(e) { console.error(e); }
})();
})();
